<div class="row-container border border-gray-400 gap-5 rounded-md pr-3 mb-2 mt-2 mr-3 pt-2 pb-1 pl-4 bg-slate-200" style="display: flex; align-items: center;">

  <!-- Selected Client Field -->
  <div class="relative border-b border-gray-400" style="height: 30px; flex-grow: 1; flex-basis: 7%; display: flex; align-items: center;">
    <input
      type="text"
      class="input-field absolute left-0 top-0 w-full h-full bg-transparent"
      [value]="selectedClient"
      readonly
    />
    <span class="floating-label absolute left-0 pointer-events-none" style="font-size: 11px;">
      Selected Client
    </span>
  </div>

  <!-- Selected Project Field -->
  <div class="relative border-b border-gray-400" style="height: 30px; flex-grow: 1; display: flex; align-items: center;">
    <input
      type="text"
      class="input-field absolute left-0 top-0 w-full h-full bg-transparent"
      [value]="selectedProject"
      readonly
    />
    <span class="floating-label absolute left-0 pointer-events-none" style="font-size: 11px;">
      Selected Project
    </span>
  </div>

</div>

